export const classes = {
  wrapper: 'place-between mb-6',
  auroraTitle:
    'text-[22px] font-bold tracking-[-0.01em] text-taupe-3 dark:text-mauve-1',
  titlesWrapper: 'mr-6',
  clickable: 'hover:underline cursor-pointer',
  buttonsWrapper: 'place-start',
  disabled: 'cursor-not-allowed',
  search: 'mr-4',
  download: 'ml-2',
  addButton: 'ml-4 px-4 py-2 text-sm',
  buttonText: 'ml-2',
  toggleBlock: 'ml-6',
  toggleIcon: 'text-lg',
  content: 'place-start',
  toggleWrapper: 'place-center',
};
